/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_SettingsInputs */

const en_import_settings = /** @type {(inputs: Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Settings`)
};

const fr_import_settings = /** @type {(inputs: Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer les paramètres`)
};

const de_import_settings = /** @type {(inputs: Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importeinstellungen`)
};

const it_import_settings = /** @type {(inputs: Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di importazione`)
};

const ru_import_settings = /** @type {(inputs: Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт настроек`)
};

const es_import_settings = /** @type {(inputs: Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de importación`)
};

const zh_cn2_import_settings = /** @type {(inputs: Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入设置`)
};

const ja_import_settings = /** @type {(inputs: Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポート設定`)
};

const hi_import_settings = /** @type {(inputs: Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग आयात करना`)
};

const pt_pt2_import_settings = /** @type {(inputs: Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de importação`)
};

/**
* | output |
* | --- |
* | "Import Settings" |
*
* @param {Import_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const import_settings = /** @type {((inputs?: Import_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_import_settings(inputs)
	if (locale === "de") return de_import_settings(inputs)
	if (locale === "it") return it_import_settings(inputs)
	if (locale === "ru") return ru_import_settings(inputs)
	if (locale === "es") return es_import_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_import_settings(inputs)
	if (locale === "ja") return ja_import_settings(inputs)
	if (locale === "hi") return hi_import_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_import_settings(inputs)
	return en_import_settings(inputs)
});